<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="经销商编号" name='dealer_sn'>
          <a-input v-model:value="search.dealer_sn" style="width:280px" placeholder="请输入经销商编号进行搜索" />
        </a-form-item>
        <a-form-item label="经销商名称" name='dealer_name'>
          <a-input v-model:value="search.dealer_name" style="width:280px" placeholder="请输入经销商名称进行搜索" />
        </a-form-item>
         <a-form-item label="经销商级别" name='dealer_level'>
          <a-select v-model:value="search.dealer_level" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option v-for='item in levelList' :key='item.level_id' :value="item.level_id">{{item.level_name}}
            </a-select-option>
          </a-select>
        </a-form-item>
           <a-form-item label="总部直属经销商" name='is_brand'>
              <customizeSwitch v-model:value="search.is_brand" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='dealer_sn' :columns='columns' :data-source='list'>
        <template v-slot:action="{ record }">
            <a v-has:onlinePriceDealerLook="()=>checkDetail(record,'detail')" href="javascript:;" class="m-r-10">查看</a>
            <a v-has:onlinePriceDealerEdit="()=>checkDetail(record,'edit')" href="javascript:;" v-if="record.is_brand">修改</a>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </a-card>
      <a-modal v-model:visible="dealerDetailVisible" centered :width="700" :footer="null" destroyOnClose>
       <dealerDetail :options="dealerData" v-on:success="successEdit" />
     </a-modal>
  </a-layout>
</template>
<script>
import { ref,  reactive, toRefs, onMounted } from "vue";
import { getDealerLevelList,} from "@/api/dealer";
import {channelDiscountRateDealer} from '@/api/online'
import { iscode } from "@/utils/app";
import store from "@/store";
import useTableSearch from "@/hooks/useTableSearch";
import { message } from 'ant-design-vue';
import dealerDetail from "./detail.vue";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
  dealer_sn: "",
  dealer_name:"",
  dealer_level:'',
  is_brand:1
};
export default {
  components: {
    dealerDetail
  },
  setup(props, ctx) {
    let columns = [
      {
          title: "经销商编号",
          dataIndex: "dealer_sn",
          key: "dealer_sn",
          fixed: 'left',
          width:150
        },
        
        {
          title: "经销商名称",
          dataIndex: "dealer_name",
          key: "dealer_name",
        },
        {
          title: "所属上级",
          dataIndex: "parent_dealer_name",
          key: "parent_dealer_name",
          width:150
        },
        {
          title: "经销商级别",
          dataIndex: "level_name",
          key: "level_name",
          width:150
        },
        
        {
          title: "订货规则",
          dataIndex: "order_set_type_text",
          key: "order_set_type_text",
        },
        {
          title: "状态",
          key: "status",
          slots: { customRender: "status" },
          customRender:({record})=>{
            return record.status==1?'正常':'禁用'
          }
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
    ];
    const state = reactive({
      levelList: []
    });
    // 获取类型列表
    const getLives = async () => {
      let res = await getDealerLevelList().then((res) => res.data);
      if (iscode(res)) {
        state.levelList = res.data;
      } else {
        message.error(res.msg);
      }
    };
    const {
      pageCurrentChange,
      pageSizeChange,
      search,
      list,
      initData,
      total,
      pageSearchChange,
      listLoading,
    } = useTableSearch({ data: defSearch });
    const tableHoosks = {
      pageCurrentChange,
      pageSizeChange,
      search,
      initData,
      list,
      total,
      pageSearchChange,
      listLoading,
    };
    onMounted(() => {
      tableHoosks.initData(channelDiscountRateDealer, search.value);
      getLives();
    });
    const form = ref();

    const dealerData=ref({})
    const dealerDetailVisible=ref(false)
    const checkDetail=(data,type)=>{
      dealerDetailVisible.value=true
      dealerData.value={}
      dealerData.value=JSON.parse(JSON.stringify({
        ...data,
        type
      }))
    }
    const successEdit=()=>{
      dealerDetailVisible.value=false
      tableHoosks.initData(channelDiscountRateDealer, search.value);
    }
    return {
      info: store.state.user.info,
      ...toRefs(state),
      ...tableHoosks,
      columns,
      form,
      successEdit,
      checkDetail,
      dealerDetailVisible,
      dealerData
    };
  },
};
</script>